<template lang="pug">
v-app#login.primary
  v-content
    v-container(fluid, fill-height)
      v-layout(align-center, justify-center)
        v-flex(xs12, sm8, md4, lg4)
          .layout.column.align-center
            img(src='@/assets/images/logo-delivery.svg', alt='Bigou Delivery', width='250', height='150')
          form(@submit.prevent="validate('login')", data-vv-scope="login")
            v-card.elevation-1.pa-3
              v-card-text
                v-text-field(append-icon='person', color="gray", label='E-mail', v-validate="'required|email'", required, :error-messages="errors.collect('email')", data-vv-name="email", type="text", v-model='model.email')
                v-text-field(append-icon='lock', color="gray", label="Senha", v-validate="'required'", required, :error-messages="errors.collect('senha')", data-vv-name="senha", type='password', v-model='model.senha')
                .layout.justify-center
                  div#turnstile-login
              v-card-actions
                v-btn(flat, color="error", type="button", @click="dialogenha=true") Esqueci minha senha
                v-spacer
                v-btn(block, color='accent', type="submit", :loading='loading') Login

  v-dialog(v-model="dialogenha", width="auto", max-width="400px")
    form(@submit.prevent="validate('recovery')" data-vv-scope="recovery")
      v-card
        v-card-title.title Recuperar Senha
        v-card-text
          v-container(grid-list-md)
            v-layout(wrap)
              v-flex.xs12
                v-text-field(append-icon='person', color="gray", data-vv-scope="formRecovery", label='E-mail', v-validate="'required|email'", required, :error-messages="errors.collect('email')", data-vv-name="email", type="text", v-model='model.email')
              v-flex.xs12
                .layout.justify-center
                  div#turnstile-recovery
        v-card-actions
          v-spacer
          v-btn(type="button", flat, color="gray darken-1", @click.native="dialogenha=false") Fechar
          v-btn(type="submit", color="accent", :loading="loading || $root.loading || $root.user !== null", :disabled="loading || $root.loading || $root.user !== null") Enviar
</template>

<script>
import Hashes from 'jshashes';
const SHA512 = new Hashes.SHA512;

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    loading: false,
    model: {},
    dialogenha: false,
    turnstileToken: null,
    turnstileTokenRecovery: null,
    turnstileWidgetId: null,
    turnstileWidgetIdRecovery: null,
  }),
  mounted () {
    this.renderTurnstile('turnstile-login', 'turnstileWidgetId', 'turnstileToken');
  },
  watch: {
    dialogenha (open) {
      if (open && this.turnstileWidgetIdRecovery === null) {
        this.$nextTick(() => this.renderTurnstile('turnstile-recovery', 'turnstileWidgetIdRecovery', 'turnstileTokenRecovery'));
      }
    },
  },
  methods: {
    renderTurnstile (elementId, widgetIdField, tokenField, attempt = 0) {
      const vm = this;
      const siteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY;
      if (!siteKey) return;
      if (!window.turnstile || !document.getElementById(elementId)) {
        if (attempt < 20) setTimeout(() => vm.renderTurnstile(elementId, widgetIdField, tokenField, attempt + 1), 250);
        return;
      }
      vm[widgetIdField] = window.turnstile.render(`#${elementId}`, {
        sitekey: siteKey,
        callback: token => { vm[tokenField] = token; },
      });
    },
    resetTurnstile (widgetIdField, tokenField) {
      const vm = this;
      vm[tokenField] = null;
      if (vm[widgetIdField] !== null && window.turnstile) window.turnstile.reset(vm[widgetIdField]);
    },
    async sendLogin (model) {
      const vm = this;
      try {
        const response = await vm.$axios.post('/login', { email: model.email.toLowerCase(), senha: SHA512.hex(model.senha), turnstileToken: vm.turnstileToken });
        const usuario = response.data;
        vm.$store.dispatch('setToken', usuario.token);
        usuario.updateConfigDelivery = true;
        vm.$store.dispatch('setUser', usuario);
        window.getApp.$emit('APP_LOGIN_SUCCESS', { login: true });
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao fazer o login. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
        vm.resetTurnstile('turnstileWidgetId', 'turnstileToken');
        vm.loading = false;
      }
    },
    async sendRecovery (model) {
      const vm = this;
      try {
        await vm.$axios.put('/password/reset', { email: model.email.toLowerCase(), turnstileToken: vm.turnstileTokenRecovery });
        vm.dialogenha = false;
        window.getApp.$emit('APP_ALERT', { color: 'success', text: `Se o e-mail inserido estiver correto, você receberá um e-mail! Verifique sua caixa de mensagem.` });
        vm.resetTurnstile('turnstileWidgetIdRecovery', 'turnstileTokenRecovery');
        vm.loading = false;
      } catch (error) {
        let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao fazer o login. Tente novamente!';
        window.getApp.$emit('APP_ALERT', { color: 'success', text: `Se o e-mail inserido estiver correto, você receberá um e-mail! Verifique sua caixa de mensagem.` });
        vm.dialogenha = false;
        vm.resetTurnstile('turnstileWidgetIdRecovery', 'turnstileTokenRecovery');
        vm.loading = false;
      }
    },
    async validate (scope) {
      let vm = this;
      try {
        vm.loading = true;
        const result = await vm.$validator.validateAll(scope);
        if (!result) throw "Preencha todos os campos corretamente!";
        if (scope === 'login') vm.sendLogin(vm.model);
        else if (scope === 'recovery') vm.sendRecovery(vm.model);
        vm.$validator.reset();
      } catch (error) {
        window.getApp.$emit("APP_ALERT", { color: "red", text: error });
        vm.loading = false;
      }
    },
  }
};
</script>

<style scoped lang="css">
#login {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
